import { formatDelta, deltaTone } from "./util";

interface ScoreDelta {
  dimension?: string;
  before_abs?: number;
  after_abs?: number;
  delta_abs?: number;
  delta_peer?: number;
}

interface ScoresPayload {
  top_score_deltas?: ScoreDelta[];
}

const DIMENSION_LABELS: Record<string, string> = {
  power: "动力",
  torque_response: "扭矩响应",
  acceleration: "加速",
  braking: "刹车",
  cornering: "弯道",
  handling_transient: "动态切换",
  steering_feel: "转向手感",
  ride_comfort: "舒适",
  refinement: "精致度",
  daily_usability: "日常可用",
  durability: "耐用",
  efficiency: "能效",
  safety: "安全",
  reliability_observed: "观察到的可靠性",
};

export function ScoresPanel({ payload }: { payload: unknown }) {
  const deltas = (payload as ScoresPayload)?.top_score_deltas ?? [];
  if (deltas.length === 0) {
    return <p className="muted small">没有评分变化。</p>;
  }
  return (
    <ul className="canvas-list scores-list">
      {deltas.map((d, idx) => {
        const tone = deltaTone(d.delta_abs);
        const label = d.dimension ? DIMENSION_LABELS[d.dimension] ?? d.dimension : "—";
        return (
          <li key={`${d.dimension ?? "row"}-${idx}`} className={`score-row tone-${tone}`}>
            <span className="score-dim">{label}</span>
            <span className="score-bar">
              <span className="score-bar-track">
                <span
                  className="score-bar-before"
                  style={{ width: `${barWidth(d.before_abs)}%` }}
                />
                <span
                  className="score-bar-after"
                  style={{ width: `${barWidth(d.after_abs)}%` }}
                />
              </span>
              <span className="score-bar-values">
                <span>{d.before_abs?.toFixed(1) ?? "—"}</span>
                <span>→</span>
                <span>{d.after_abs?.toFixed(1) ?? "—"}</span>
              </span>
            </span>
            <span className="score-delta">{formatDelta(d.delta_abs, 1)}</span>
          </li>
        );
      })}
    </ul>
  );
}

function barWidth(value: number | undefined): number {
  if (typeof value !== "number") return 0;
  // Scores are 0–10 in this domain; clamp gently and scale for visual diff.
  return Math.max(2, Math.min(100, (value / 10) * 100));
}
